export const CURRENCY_BY_CODE = {
  RUB: 'рубли',
  KZT: 'тенге',
  KGS: 'сом',
  TJS: 'сомони',
  UZS: 'сум',
};
